import type { StateCreator } from "zustand";

import type { SimpleModalDescriptor } from "../services/simple-modal/simple-modal-types";

export interface SimpleModalSlice {
    simpleModalDescriptor: SimpleModalDescriptor | null; // what to render (persists through exit animation)
    isSimpleModalOpen: boolean; // handles modal visibility
    openSimpleModal: (modal: SimpleModalDescriptor) => void;
    closeSimpleModal: () => void;
    clearSimpleModalDescriptor: () => void;
}

export const createSimpleModalSlice: StateCreator<SimpleModalSlice, [], [], SimpleModalSlice> = (set) => ({
    simpleModalDescriptor: null,
    isSimpleModalOpen: false,
    openSimpleModal: (modal) => set({ simpleModalDescriptor: modal, isSimpleModalOpen: true }),
    // Only handle dismissing the modal, leave the content intact for now.
    closeSimpleModal: () => set({ isSimpleModalOpen: false }),
    // Clear the descriptor separately (eg. after the exit animation completes)
    clearSimpleModalDescriptor: () => set({ simpleModalDescriptor: null }),
});
